import { notifications } from '@mantine/notifications';
import { api } from '~/trpc-extra/api';

// Call AI to update the step description (also known as step prompt)
export function useUpdateStepDescription({
  testContentId,
  callbacks,
}: {
  testContentId: string;
  callbacks?: { onSuccess?: () => void };
}) {
  const trpcUtils = api.useUtils();
  const { mutateAsync: updateStepDescription, isPending: isUpdating } =
    api.testStep.updateStepDescriptionWithAi.useMutation({
      onSuccess: (description, { stepId }) => {
        if (description) {
          const prevData = trpcUtils.testContent.get.getData({ id: testContentId });
          if (!prevData) {
            return;
          }
          const newData = {
            ...prevData,
            steps: prevData.steps.map((step) => (step.id === stepId ? { ...step, description } : step)),
          };
          trpcUtils.testContent.get.setData({ id: testContentId }, newData);
        }
        callbacks?.onSuccess?.();
      },
      onError: () => {
        notifications.show({ message: 'Error updating the step prompt', color: 'red' });
      },
    });

  return { updateStepDescription, isUpdating };
}
